import { render, staticRenderFns } from "./TrailResume.vue?vue&type=template&id=18d10f1e&scoped=true"
import script from "./TrailResume.vue?vue&type=script&lang=js"
export * from "./TrailResume.vue?vue&type=script&lang=js"
import style0 from "./TrailResume.vue?vue&type=style&index=0&id=18d10f1e&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "18d10f1e",
  null
  
)

export default component.exports